import { AuditoriaBeanM } from './auditoria_bean';
import { ServiceCredencialesM } from './service-credenciales-bean';


export class MaePlantillaE {
  c_plantilla:Number;
  x_nombre:String;
  x_descripcion:String;
  c_estado:Number;
  x_uid:String;
  x_archivo_ext:String;
  auditoriaBeanM:AuditoriaBeanM;
  serviceCredencialesM:ServiceCredencialesM;
  }


  export class MaePlantillaM {
    c_plantilla:Number;
    x_nombre:String;
    x_descripcion:String;
    c_estado:Number;
    x_estado:String;
    x_uid:String;
    x_archivo_ext:String;
    }
